<template lang="pug">
  LayoutDefault
    .page: .container-fluid
      .section
        .heading--section Business News

      .section
        .card: .card--body
          .row.no-gutters.align-items-center
            .col-sm-auto
              .mar_r--10
                span.text--size_12.text__uppercase 
                  | Filter by counter 
                span.text--size_12.mar_l--10.text--color_grey.hidden_xsm
                  font-awesome-icon(icon="angle-right")
            .col-sm.mar_t--10-xsm
              SelectSingleStock(@stockSelected="UPDATE_STOCK_SELECTION", :defaultCounterCode="stockCode")

      .section
        .card: .card--body
          .pad_b--25.text-muted(v-if="currentStockText")
            | Showing News related to counter <strong style="color: #000;">{{ currentStockText }}</strong>.
          Loading(:isLoading="isDataLoading", type="bar")
            DataTable(
              :records="news", 
              :headers="headers", 
              :itemsPerPageOptions="[25, 50, 75, 100]",
              :emptyDisplayMessage="`No records found. There are currently no news available related to the counter chosen. Please choose a different counter to read more news.`",
              tableBreak="md",
            )
              template(v-slot:slot-for-date="item")
                | {{ item.record.attributes.date }}

              template(v-slot:slot-for-title="item")
                a.link__primary_light(href="#", @click.prevent="OPEN_INFO_MODAL({ content: item.record.attributes.content, title: item.record.attributes.title, date: item.record.attributes.date, time: item.record.attributes.time, author: item.record.attributes.author, provider: item.record.attributes.provider, link: item.record.attributes.link, news_item: item, relatedCounters: item.record.relationship.counters.data })")
                  small.mr-2: i.fas.fa-external-link-alt
                  span(v-html="item.record.attributes.title")

              template(v-slot:slot-for-provider="item")
                span.text--size_11.text__uppercase {{ item.record.attributes.provider }}


      NewsModal(
        :modalShow="newsModal.isShown",
        :news="newsModal.payload", 
        @close="newsModal.isShown = false"
      )

</template>



<script>
  import { mapGetters, mapActions } from 'vuex';

  import setStockCode from '../../mixins/setStockCodes';
  import requestHandlers from '../../mixins/requestHandlers';

  import DataTable from '../../components/DataTable';
  import Loading from '../../components/Loading';
  import CounterDropdown from '../../components/CounterDropdown';
  import SelectSingleStock from '../../components/SelectSingleStock';
  import NewsModal from '../../components/NewsModal';

  export default {
    name: 'News',
    mixins: [requestHandlers, setStockCode],
    components: {
      DataTable,
      Loading,
      SelectSingleStock,
      CounterDropdown,
      NewsModal
    },

    data() {
      return {
        news: [],
        headers: [
          {
            id: 'date',
            text: 'Date',
            type: 'custom_slot',
            colWidth: 15,
          },
          {
            id: 'title',
            text: 'News Title',
            type: 'custom_slot',
            colWidth: 70,
          },
          {
            id: 'provider',
            text: 'Source',
            type: 'custom_slot',
            colWidth: 15,
            colAlignment: 'center',
          },
        ],

        newsModal: {
          isShown: false,
          payload: {},
        },
      }
    },

    computed: {
      ...mapGetters('stock', {
        allStocks: 'dropdownOptions'
      }),
      currentStockText() {
        let _obj = this.allStocks.find(a => {
          return a.value === this.stockCode;
        });

        if(_obj && _obj.hasOwnProperty('text') && _obj.value != null) {
          return _obj.text;
        } else {
          return '';
        }
      }
    },

    methods: {
      ...mapActions('stock', [
        'setCurrentStock' 
      ]),

      FETCH_RECORDS() {
        this.REQUEST_INIT();

        // Set params from route's query string is exists
        let params = { };

        if(this.stockCode !== '') {
          params['filter[stockCode]'] = this.stockCode;
        }
        
        this.$axios.get('/News/Latest', { params })
        .then(response => {
          if(response.status === 200) {
            this.news = response.data.data;
          }
        })
        .catch(error => this.HANDLE_ERROR_GENERIC(error))
        .then(response => this.REQUEST_FINALLY());
      },

      OPEN_INFO_MODAL(payload) {
        this.newsModal.payload = payload;
        this.newsModal.isShown = true;
      },

      UPDATE_STOCK_SELECTION(stockCode) {
        this.setCurrentStock(stockCode);
        this.$router.push({query: { stockCode: stockCode}})
      },

    },



    beforeRouteUpdate(to, from, next) {
      this.FETCH_RECORDS();
      next();
    },

    created() {
      this.FETCH_RECORDS();
    },
  }

</script>




<style lang="scss">
	
</style>
